<template>
  <div>
    <div class="text-center" v-if="!departmentDataLoaded || !chapterDataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mx-4" v-if="departmentDataLoaded">
      <div v-show="chapterDataLoaded">
        <PageTitle title="Разделы расписания" />

        <v-row class="my-0">
          <v-col cols="12" class="pt-0 pb-5">
            <h4 class="department">{{ departmentName }}</h4>
          </v-col>
        </v-row>

        <ChaptersTable
          @dataLoaded="chapterDataLoaded = true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '@/components/ui/Title'
import ChaptersTable from '@/components/department/chapters/Table'

export default {
  name: 'Chapters',

  metaInfo: {
    title: 'Разделы расписания'
  },

  components: {
    PageTitle,
    ChaptersTable
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.$store.dispatch('department/checkDepartmentInLocalStorage')
    this.departmentDataLoaded = true
  },

  mounted() {
    this.hideHtmlOverflow()
  },

  destroyed() {
    this.showHtmlOverflow()
  },

  data: () => ({
    departmentDataLoaded: false,
    chapterDataLoaded: false
  }),

  computed: {
    ...mapGetters('department', ['departmentName'])
  },

  methods: {
    hideHtmlOverflow() {
      document.querySelector('html').style.setProperty('overflow-y', 'hidden', 'important')
    },

    showHtmlOverflow() {
      document.querySelector('html').style.overflowY = 'visible'
    }
  }
}
</script>